import { windowWidth } from "@styles/global";
import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
`;

const FormContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  flex-direction: column;

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 90%;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export { Container, FormContainer };
